var render = function render() {
  var _vm$bookLiveInfos, _vm$bookLiveInfos2, _vm$State$recordObj, _vm$State$recordObj$t, _vm$State$deviceTypeM;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container",
    class: {
      'share': _vm.singChannel.shareCode,
      'fullScreen': _vm.fullScreen,
      'showChat': _vm.showChat,
      'down': _vm.fullScreen && !_vm.State.showFootBar
    },
    attrs: {
      "title": _vm.showNickName
    }
  }, [_c('div', {
    staticClass: "hide",
    staticStyle: {
      "position": "absolute",
      "z-index": "100"
    }
  }, [_vm._v("r:" + _vm._s(_vm.singChannel.id) + ", p:" + _vm._s(_vm.singChannel.channel) + ", muteVideo:" + _vm._s(_vm.muteVideo))]), _c('div', {
    staticClass: "nickNameBox"
  }, [_vm._v(_vm._s(_vm.nickName))]), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    ref: "videoCon",
    staticClass: "video-con hasTrack",
    class: {
      mainWindow: _vm.title === 'PGM' || _vm.title === 'VFB' || _vm.title === 'Share',
      screenCenter: !_vm.singChannel.hasUnsubscribe && _vm.State.audioType !== 1 && _vm.singChannel.id != _vm.userInfo.rtilCode && (_vm.$route.name == 'party' || _vm.$route.name == 'partyParticipate')
    },
    style: {
      'background': _vm.isRotated ? 'black' : ''
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showVideoBg && !_vm.anywhereSetting || _vm.anywherePopShow,
      expression: "(showVideoBg && !anywhereSetting)||(anywherePopShow)"
    }],
    staticClass: "videoBg",
    class: {
      private: _vm.praviteEach
    }
  }, [_vm.avatarBgColor ? _c('div', {
    ref: "avatar",
    staticClass: "avatar",
    style: {
      background: _vm.avatarBgColor
    }
  }, [!_vm.avatarImage ? _c('span', {
    ref: "avatarText",
    style: {
      fontSize: _vm.avatarFontsize + 'px'
    }
  }, [_vm._v(_vm._s(_vm.firstName && _vm.firstName || _vm.nickName && _vm.nickName.charAt(0)))]) : _c('img', {
    attrs: {
      "src": _vm.avatarImage
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "videoBgText"
  }, [(_vm.nickName || _vm.title) && _vm.title != _vm.singChannel.id && _vm.nickName != _vm.singChannel.id && (_vm.State.audioType === 0 || _vm.State.audioType === 2) || _vm.muteVideo && _vm.nickName != _vm.singChannel.id || _vm.anywherePopShow ? _c('span', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.nickName || _vm.title) + _vm._s(_vm.tagName ? ` / ${_vm.tagName}` : '') + " ")]) : _vm._e(), _vm.userInfo.rtilCode == _vm.singChannel.id && _vm.nickName ? _c('span', {
    staticClass: "meTitle"
  }, [_vm._v("(" + _vm._s(_vm.$t('kioskHost.me')) + ")")]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.singChannel.videoTrack && _vm.$route.name === 'interviewParticipate' && _vm.title === 'mainwindow',
      expression: "!singChannel.videoTrack && $route.name === 'interviewParticipate' && title === 'mainwindow'"
    }],
    staticClass: "showBg"
  }, [_c('span', {
    staticClass: "bgContent"
  }, [_c('img', {
    staticClass: "tvuLogo",
    attrs: {
      "src": _vm.logoGray
    }
  }), _c('p', [_vm._v(_vm._s(_vm.$t('mainWindow.noVideoReturn')))])])])])]), _vm._t("default"), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('mainWindow.unpinTips')
    }
  }, [_vm.outputRtilCode == _vm.singChannel.id && _vm.userInfo.channelMode == 0 && _vm.userInfo.owner && _vm.$route.name != 'interview' ? _c('span', {
    staticClass: "unpinBox",
    on: {
      "click": function ($event) {
        return _vm.setMainwindow('cancelMainWindow');
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-Vector3"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('mainWindow.unpin')))])]) : _vm._e()]), _vm.singChannel.hasUnsubscribe && _vm.State.audioType != 2 ? _c('div', {
    staticClass: "noSubscribe"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('operationBtn.AudioOnlyEnabled')))])]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !(_vm.$route.name == 'party' && _vm.singChannel.id == _vm.userInfo.rtilCode) && !(_vm.$route.name == 'partyParticipate' && _vm.singChannel.id === _vm.userInfo.rtilCode) || _vm.outputRtilCode == _vm.userInfo.rtilCode,
      expression: "(!($route.name == 'party'&&singChannel.id == userInfo.rtilCode)\n        &&!($route.name == 'partyParticipate'&&singChannel.id === userInfo.rtilCode))\n        ||(outputRtilCode == userInfo.rtilCode)"
    }],
    ref: "videoTest",
    staticClass: "videoBox",
    class: _vm.returnVideoClass
  }), !_vm.anywhereSetting && !_vm.fullScreen && _vm.isAudioLevel && _vm.showTitle && !_vm.singChannel.leave ? _c('div', {
    staticClass: "audioBox"
  }, [_c('canvas', {
    class: this.singChannel.id + 'Left'
  }), _c('canvas', {
    class: this.singChannel.id + 'Right'
  })]) : _vm._e(), !_vm.anywhereSetting && !_vm.anywherePopShow ? _c('VideoControl', {
    ref: "videoControl",
    class: _vm.addPipClass,
    attrs: {
      "pipVolume": _vm.pipVolume,
      "devicePlatform": _vm.devicePlatform,
      "deviceType": _vm.sourceType || _vm.deviceType,
      "muteAudioIcon": _vm.muteAudioIcon,
      "hearSelf": _vm.hearSelf,
      "userInfo": _vm.userInfo,
      "asRoleList": _vm.asRoleList,
      "degreeHost": _vm.degreeHost,
      "unSubscribe": _vm.singChannel.hasUnsubscribe,
      "videoObj": _vm.$refs['videoTest'],
      "singChannel": _vm.singChannel,
      "outputRtilCode": _vm.outputRtilCode
    },
    on: {
      "callback": _vm.controlCallback
    }
  }) : _vm._e(), _vm.singChannel.id && _vm.showOperateBox && _vm.State.showFootBar && !_vm.anywhereSetting && !_vm.anywherePopShow ? _c('div', {
    staticClass: "operateBox",
    class: {
      hideMicOrCamera: !_vm.showMuteIcons && !_vm.showTitle,
      noBg: _vm.$route.name === 'kioskParticipate' && !_vm.showMuteIcons
    }
  }, [_c('div', {
    staticClass: "column clearfix"
  }, [_vm.showMuteIcons ? _c('div', {
    staticClass: "iconBox"
  }, [_vm.$scopedSlots['videoBottom'] ? _c('i', {
    class: {
      'el-icon-arrow-down': _vm.showVideoBottom,
      'el-icon-arrow-up': !_vm.showVideoBottom
    },
    on: {
      "click": _vm.controlUpDown
    }
  }) : _vm._e(), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.muteAudioIcon && _vm.showDiv,
      expression: "!muteAudioIcon && showDiv"
    }],
    staticClass: "micphone",
    class: {
      'cancelCursorPoint': _vm.showPipCursorPointer
    },
    attrs: {
      "title": _vm.level.toFixed(2) * 100
    },
    on: {
      "click": function ($event) {
        return _vm.setVideoAndAudio('muteAudio', false);
      }
    }
  }, [_c('micphone', {
    attrs: {
      "level": _vm.level,
      "isAudioLevel": _vm.isAudioLevel
    }
  })], 1), _vm.muteAudioIcon && _vm.showDiv ? _c('svg', {
    staticClass: "muteAudioImg",
    class: {
      'cancelCursorPoint': _vm.showPipCursorPointer
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        return _vm.setVideoAndAudio('muteAudio', true);
      }
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-universal_micoff"
    }
  })]) : _vm._e(), _c('device-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.devicesInfo.microphoneList && _vm.devicesInfo.microphoneList.length && _vm.showDiv,
      expression: "devicesInfo.microphoneList && devicesInfo.microphoneList.length && showDiv"
    }],
    attrs: {
      "title": _vm.$t('operationBtn.selectMicrophone'),
      "type": "audio",
      "deviceSelectId": _vm.devicesInfo.microphoneId,
      "data": _vm.devicesInfo.microphoneList,
      "rtilCode": this.singChannel.id,
      "appendToBody": true,
      "userInfoRtilcode": _vm.userInfo.rtilCode
    },
    on: {
      "changeDevice": _vm.changeDevice
    }
  }), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.muteVideoIcon && _vm.showDiv,
      expression: "!muteVideoIcon && showDiv"
    }],
    staticClass: "iconfont icon-universal_cameraon camera",
    class: {
      'cancelCursorPoint': _vm.showPipCursorPointer
    },
    on: {
      "click": function ($event) {
        return _vm.setVideoAndAudio('muteVideo', false);
      }
    }
  }), _vm.muteVideoIcon && _vm.showDiv ? _c('svg', {
    staticClass: "muteVideoImg",
    class: {
      'cancelCursorPoint': _vm.showPipCursorPointer
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        return _vm.setVideoAndAudio('muteVideo', true);
      }
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-universal_cameraoff"
    }
  })]) : _vm._e(), _c('device-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.devicesInfo.cameraList && _vm.devicesInfo.cameraList.length && _vm.showDiv,
      expression: "devicesInfo.cameraList && devicesInfo.cameraList.length && showDiv"
    }],
    attrs: {
      "title": _vm.$t('operationBtn.selectCamera'),
      "type": "video",
      "deviceSelectId": _vm.devicesInfo.cameraId,
      "data": _vm.devicesInfo.cameraList,
      "rtilCode": this.singChannel.id,
      "appendToBody": true
    },
    on: {
      "changeDevice": _vm.changeDevice
    }
  }), _c('el-tooltip', [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showCommonPrivateIcon,
      expression: "showCommonPrivateIcon"
    }],
    staticClass: "iconfont pointer",
    class: _vm.returnPrivateClass,
    attrs: {
      "placement": "top"
    },
    on: {
      "click": _vm.controlPrivate
    }
  }), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "text title",
    domProps: {
      "innerHTML": _vm._s(_vm.retrunIntercomTips)
    }
  })])]), _vm.asRoleList.length && _vm.showDiv ? _c('div', {
    staticClass: "setRole"
  }, [_c('operate-button', {
    ref: "role",
    attrs: {
      "btnList": _vm.asRoleList,
      "userInfo": _vm.userInfo,
      "singChannel": _vm.singChannel,
      "nickName": _vm.nickName,
      "title": _vm.$t('authorizeOperation.role'),
      "activeBg": "green",
      "type": "asRole",
      "currentRole": _vm.currentRole,
      "deviceType": _vm.sourceType || _vm.deviceType
    },
    on: {
      "callback": _vm.operateCallback
    }
  })], 1) : _vm._e(), _vm._t("iconSlot"), _c('voip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.judgeShowVoIP,
      expression: "judgeShowVoIP"
    }],
    ref: "voip",
    attrs: {
      "selectRid": _vm.selectRid,
      "userInfo": _vm.userInfo,
      "rtilCode": _vm.singChannel.id,
      "memberId": _vm.singChannel.tid,
      "nickName": _vm.nickName
    }
  })], 2) : _vm._e(), _c('div', {
    ref: "parentNickNameBox",
    staticClass: "infoBox",
    class: {
      active: _vm.praviteEach,
      'editTitle': _vm.editTitle,
      danger: _vm.theme == 'danger',
      smallVideo: !_vm.showDiv
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: this.setTag == 'isSetTag' || _vm.State.partyTag == _vm.singChannel.id,
      expression: "this.setTag=='isSetTag'|| State.partyTag == singChannel.id "
    }],
    staticClass: "iconfont icon-default1",
    staticStyle: {
      "margin-right": "4px",
      "color": "#33aa50",
      "margin-top": "-1px"
    }
  }), _vm.showTitle ? _c('div', {
    ref: "nickNameBox",
    staticClass: "title clearfix",
    class: {
      isMe: _vm.userInfo.rtilCode == _vm.singChannel.id && _vm.nickName
    },
    attrs: {
      "title": _vm.nickName
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showTitle && !_vm.showEditInput && !_vm.singChannel.shareCode,
      expression: "showTitle && !showEditInput && !singChannel.shareCode"
    }],
    ref: "titleBox",
    staticClass: "left titleBox",
    class: `${_vm.nameColor}`
  }, [_vm.theme != 'danger' && _vm.nickName != _vm.singChannel.id && _vm.nickName ? _c('div', {
    staticClass: "name",
    class: _vm.showRedClass
  }, [_c('span', [_vm._v(_vm._s(_vm.nickName || _vm.title) + _vm._s(_vm.tagName ? ` / ${_vm.tagName}` : ''))]), _vm.userInfo.rtilCode == _vm.singChannel.id && _vm.nickName ? _c('span', {
    staticClass: "meTitle"
  }, [_vm._v(" (" + _vm._s(_vm.$t('kioskHost.me')) + ") ")]) : _vm._e()]) : _vm._e(), _vm.nickName ? _c('div', {
    staticClass: "rename",
    on: {
      "click": _vm.editName
    }
  }, [_c('i', {
    staticClass: "el-icon-edit"
  }), _vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.partyOperation.rename')))]) : _vm._e()]), _vm.showEditInput ? _c('el-input', {
    ref: "name",
    class: {
      red: _vm.redTip
    },
    attrs: {
      "maxlength": 32,
      "autofocus": true
    },
    on: {
      "blur": function ($event) {
        _vm.showEditInput = false;
      }
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.saveName.apply(null, arguments);
      }
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  }) : _vm._e(), _vm.redTip && _vm.showEditInput ? _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.redTip))]) : _vm._e()], 1) : _vm._e(), _vm.operateList.length ? _c('div', {
    ref: "appendTitleWidth",
    staticClass: "appendTitle right"
  }, [_vm.showTitle && _vm.nickName || !_vm.nickName && !_vm.singChannel.leave ? _c('el-divider', {
    staticClass: "line",
    attrs: {
      "direction": "vertical"
    }
  }) : _vm._e(), _c('operate-button', {
    attrs: {
      "btnList": _vm.operateList,
      "userInfo": _vm.userInfo,
      "singChannel": _vm.singChannel,
      "nickName": _vm.nickName,
      "organization": _vm.organization,
      "sourceLiveStatus": _vm.buttonStatus,
      "currentRole": _vm.currentRole,
      "liveInfo": _vm.liveInfo,
      "deviceType": _vm.sourceType || _vm.deviceType
    },
    on: {
      "callback": _vm.operateCallback,
      "setTag": _vm.updateTag
    }
  })], 1) : _vm._e()])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showVideoBottom,
      expression: "showVideoBottom"
    }],
    staticClass: "videoBottom"
  }, [_vm._t("videoBottom")], 2)]) : _vm._e(), _vm.showTips ? _c('p', {
    staticClass: "initCameraTips"
  }, [_vm._v(_vm._s(_vm.$t('common.initVideoTrack')))]) : _vm._e(), _vm.State.showInitCameraTips && _vm.title === 'Me' ? _c('p', {
    staticClass: "initCameraTips"
  }, [_vm._v(_vm._s(_vm.$t('common.initCameraTips', {
    name: _vm.State.cameraName
  })))]) : _vm._e()], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.singChannel.shareCode && _vm.singChannel.shareCode == _vm.singChannel.id,
      expression: "singChannel.shareCode && singChannel.shareCode == singChannel.id"
    }],
    staticClass: "bottom-video-bar-wrapper",
    class: {
      liveTop: _vm.singChannel.shareCode == _vm.singChannel.id && _vm.showVideoBottom
    }
  }, [_vm.$scopedSlots['videoBottom'] ? _c('i', {
    staticClass: "liveArrow",
    class: {
      'el-icon-arrow-down': _vm.showVideoBottom,
      'el-icon-arrow-up': !_vm.showVideoBottom
    },
    on: {
      "click": function ($event) {
        _vm.showVideoBottom = !_vm.showVideoBottom;
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "bottom-box-left"
  }, [_c('span', {
    staticClass: "shareNickName ellipsis",
    attrs: {
      "title": _vm.nickName
    }
  }, [_vm._v(_vm._s(_vm.nickName))]), _vm._v(" " + _vm._s(_vm.$t('partylineGuest.isSharing')))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$route.name == 'party' || _vm.$route.name == 'partyParticipate',
      expression: "$route.name == 'party' || $route.name == 'partyParticipate'"
    }],
    staticClass: "bottom-box-right"
  }, [!_vm.hasLeftDisplay ? _c('i', {
    staticClass: "iconfont icon-chat-small allScreenIcon pointer",
    on: {
      "click": function ($event) {
        return _vm.checkAll(_vm.singChannel, true);
      }
    }
  }) : _c('i', {
    staticClass: "iconfont icon-a-kongjianzuoyoubujuon pointer",
    on: {
      "click": function ($event) {
        return _vm.checkAll(_vm.singChannel, false);
      }
    }
  }), _vm.returnShowShareDot ? _c('el-divider', {
    attrs: {
      "direction": "vertical"
    }
  }) : _vm._e(), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "300",
      "popper-class": "sideTips videoControl",
      "trigger": "click",
      "visible-arrow": "false"
    },
    model: {
      value: _vm.showUpinMainwindow,
      callback: function ($$v) {
        _vm.showUpinMainwindow = $$v;
      },
      expression: "showUpinMainwindow"
    }
  }, [_c('div', {
    staticClass: "popupBox"
  }, [_vm.singChannel.id == _vm.outputRtilCode ? _c('div', {
    staticClass: "pointer",
    on: {
      "click": function ($event) {
        return _vm.setMainwindow('cancelMainWindow');
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-Vector3 grayColor"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('btnText.unMainwindow.text')))])]) : _c('div', {
    staticClass: "pointer",
    on: {
      "click": function ($event) {
        return _vm.setMainwindow('upMainwindow');
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-Vector3 grayColor"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('btnText.mainwindow.text')))])])]), _vm.returnShowShareDot ? _c('i', {
    staticClass: "iconfont icon-universal_3-dots pointer",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }) : _vm._e()])], 1)]), _c('div', {
    staticClass: "topLeft clearfix"
  }, [_vm.liveInfo.peerId && _vm.liveInfo.channel == _vm.singChannel.channel ? _c('div', {
    staticClass: "liveSign"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.liveInfo.name,
      "placement": "top"
    }
  }, [_c('span', [_vm._v("· " + _vm._s(_vm.$t('remainWords.live')))])])], 1) : _vm.$route.name == 'interview' && (_vm$bookLiveInfos = _vm.bookLiveInfos) !== null && _vm$bookLiveInfos !== void 0 && _vm$bookLiveInfos.bookLives && (_vm$bookLiveInfos2 = _vm.bookLiveInfos) !== null && _vm$bookLiveInfos2 !== void 0 && _vm$bookLiveInfos2.partyCode && !_vm.singChannel.id ? _c('div', {
    staticClass: "bookLiveSign"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('remainWords.liveBookTitle'),
      "placement": "top"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('remainWords.liveBook')))])])], 1) : _vm._e(), _c('RemoteNetWork', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showNetStatus,
      expression: "showNetStatus"
    }],
    attrs: {
      "remoteNetWorks": _vm.remoteNetWorks
    },
    on: {
      "callBack": _vm.getRemoteNetWorkIconColor
    }
  }), !_vm.anywhereSetting && (_vm$State$recordObj = _vm.State.recordObj) !== null && _vm$State$recordObj !== void 0 && (_vm$State$recordObj$t = _vm$State$recordObj[this.singChannel.id]) !== null && _vm$State$recordObj$t !== void 0 && _vm$State$recordObj$t.status && ((_vm$State$deviceTypeM = _vm.State.deviceTypeMap) === null || _vm$State$deviceTypeM === void 0 ? void 0 : _vm$State$deviceTypeM[this.singChannel.id]) == 'Anywhere' ? _c('div', {
    staticClass: "recContent"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('remainWords.stopRecording'),
      "placement": "top"
    }
  }, [_c('div', {
    staticClass: "rec-box"
  }, [_c('div', {
    staticClass: "rec-dot"
  }), _c('div', {
    staticClass: "rec-text"
  }, [_vm._v("REC")]), _c('div', {
    staticClass: "timer"
  }, [_vm._v(_vm._s(_vm.formattedTime))])])])], 1) : _vm._e(), _vm._t("topLeftSolt")], 2), _c('div', {
    staticClass: "topRight"
  }, [_vm.$route.name === 'interviewParticipate' && _vm.slotNum ? _c('span', {
    staticClass: "slotBox"
  }, [_vm._v(_vm._s(_vm.slotNum))]) : _vm._e(), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.audioMatrixIconTips,
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.audioMatrixIcon
  })])], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };